import { paramsFromObject } from "../assets/js/utils/functions";
import {
  GetFeaturedOrTopItemsParams,
  GetHighlightBySlugParams,
  GetRelatedItemsParams,
  GetStoreHighlightsParams,
  GetStoreItemsParams,
  VerifyCouponsParams,
} from "./interfaces/items.interface";
import { request } from "./utils";

export interface PaginateSearchParams {
  page?: number;
  per_page?: number;
}

const GetStoreItems = (data: GetStoreItemsParams) => {
  const params = paramsFromObject(data);
  return request(`items/public?${params}`, "get");
};

const GetFeaturedOrTopItems = (data: GetFeaturedOrTopItemsParams) => {
  const params = paramsFromObject(data);
  return request(`items/public/featured-or-top?${params}`, "get");
};

const GetCoupons = (data: PaginateSearchParams) => {
  const params = paramsFromObject(data);
  return request(`coupons?${params}`, "get");
};

const VerifyCoupon = (data: VerifyCouponsParams) => {
  return request(`coupons/verify`, "post", { data });
};

const GetRelatedItems = (data: GetRelatedItemsParams) => {
  const params = paramsFromObject(data);
  return request(`items/${data.id}/related?${params}`, "get");
};

const GetStoreHighlights = (data: GetStoreHighlightsParams) => {
  const params = paramsFromObject(data);
  return request(`item-highlights/public?${params}`, "get");
};

const GetHighlightBySlug = (data: GetHighlightBySlugParams) => {
  const params = paramsFromObject(data);
  return request(`item-highlights/slug/${data.slug}`, "get");
};

export {
  GetStoreItems,
  GetCoupons,
  VerifyCoupon,
  GetRelatedItems,
  GetFeaturedOrTopItems,
  GetStoreHighlights,
  GetHighlightBySlug,
};
